<template>
  <v-layout row align-end></v-layout>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SimpleNumberInput from "@/components/widget/input/SimpleNumberInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import SelectableDriverInput from "@/components/widget/input/SelectableDriverInput.vue";

export default {
  name: "PassengerFindDetails",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    BookingDateInput,
    SimpleTextInput,
    SelectableInput,
    SimpleNumberInput,
    SelectableDriverInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object
  },
  computed: {
    bookingIsNotBooked() {
      return this.bookingForm.booking.state == null;
    },
    bookingIsCancelled() {
      return this.bookingForm.booking.state == "cancelled";
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    changeFlightNumber(flight_number) {
      this.bookingForm.booking.flight_number = flight_number;
    },
    changeMeetAndGreet(meet_and_greet) {
      this.bookingForm.booking.meet_and_greet = meet_and_greet;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}
</style>
